import { getOrCreateAnalytics } from './analytics';
import {
	AUTH0_REDIRECT_BACK_TIME,
	EPIC_LOGIN_DOC_REDIRECT_TIME,
	GET_EPIC_TOKEN_AND_APP_CONTEXT_REQUEST_TIME,
	GET_EPIC_TOKEN_AND_APP_CONTEXT_RESPONSE_TIME,
	REDIRECTING_TO_AUTH0_TIME,
	REDIRECTING_TO_EPIC_TIME,
	REDIRECTING_TO_SUMMARY_TIME,
	REQUEST_TIME_GET_USER_META_DATA,
	REQUEST_TO_AUTH0_TOKEN_TIME,
	RESPONSE_FROM_AUTH0_TOKEN_TIME,
	RESPONSE_TIME_GET_USER_META_DATA,
	SMART_ON_FHIR_LUNCH_TIME,
} from './consts';
import { getOrCreateLogger } from './logger';

export const callTrackingApplicationLoadTime = (): void => {
	if (localStorage.getItem(SMART_ON_FHIR_LUNCH_TIME) && localStorage.getItem(AUTH0_REDIRECT_BACK_TIME)) {
		const redirectBackTime = parseInt(localStorage.getItem(AUTH0_REDIRECT_BACK_TIME) || '0', 10);

		const lunchTime = parseInt(localStorage.getItem(SMART_ON_FHIR_LUNCH_TIME) || '0', 10);

		const redirectTimeFromAuth0 = parseInt(localStorage.getItem(REDIRECTING_TO_AUTH0_TIME) || '0', 10);

		const redirectTimeFromEpic = parseInt(localStorage.getItem(REDIRECTING_TO_EPIC_TIME) || '0', 10);

		const requestTimeGetUserMetaData = parseInt(localStorage.getItem(REQUEST_TIME_GET_USER_META_DATA) || '0', 10);

		const responseTimeGetUserMetaData = parseInt(localStorage.getItem(RESPONSE_TIME_GET_USER_META_DATA) || '0', 10);

		const redirectToSummaryTime = parseInt(localStorage.getItem(REDIRECTING_TO_SUMMARY_TIME) || '0', 10);

		const redirectToDocsTime = parseInt(localStorage.getItem(EPIC_LOGIN_DOC_REDIRECT_TIME) || '0', 10);

		const requestTimeGetEpicTokenAndAppcContext = parseInt(
			localStorage.getItem(GET_EPIC_TOKEN_AND_APP_CONTEXT_REQUEST_TIME) || '0',
			10,
		);
		const responseTimeGetEpicTokenAndAppcContext = parseInt(
			localStorage.getItem(GET_EPIC_TOKEN_AND_APP_CONTEXT_RESPONSE_TIME) || '0',
			10,
		);

		const requestTimeToAuth0 = parseInt(localStorage.getItem(REQUEST_TO_AUTH0_TOKEN_TIME) || '0', 10);

		const responseTimeFromAuth0 = parseInt(localStorage.getItem(RESPONSE_FROM_AUTH0_TOKEN_TIME) || '0', 10);

		const auth0TokenResponseTime = responseTimeFromAuth0 - requestTimeToAuth0;

		const isEpicDocFlow = Boolean(redirectToDocsTime);

		const redirectTime = redirectTimeFromAuth0 !== 0 ? redirectTimeFromAuth0 : redirectTimeFromEpic;

		const applicationLoadTimeCompleteFlow = new Date().getTime();
		const timeDiffBetweenLunchToRedirect = redirectTime - lunchTime;
		const timeDiffBetweenRedirectToRedirectBack = redirectBackTime - redirectTime;

		const timeDiffBetweenRedirectBackToApiCall =
			requestTimeToAuth0 !== 0
				? requestTimeToAuth0 - redirectBackTime
				: requestTimeGetUserMetaData !== 0
					? requestTimeGetUserMetaData - redirectBackTime
					: requestTimeGetEpicTokenAndAppcContext - redirectBackTime;

		const timeDifffGetUserMetaDataResponse = responseTimeGetUserMetaData - requestTimeGetUserMetaData;
		const loadingSummeryTime = redirectToSummaryTime ? applicationLoadTimeCompleteFlow - redirectToSummaryTime : 0;
		const loadingDocsTime = redirectToDocsTime ? applicationLoadTimeCompleteFlow - redirectToDocsTime : 0;
		const completeLoadingTime = applicationLoadTimeCompleteFlow - lunchTime;

		const timeDiffGettingEpicTokenAndContextData =
			responseTimeGetEpicTokenAndAppcContext - requestTimeGetEpicTokenAndAppcContext;

		localStorage.removeItem(SMART_ON_FHIR_LUNCH_TIME);
		localStorage.removeItem(AUTH0_REDIRECT_BACK_TIME);
		localStorage.removeItem(REDIRECTING_TO_AUTH0_TIME);
		localStorage.removeItem(REQUEST_TIME_GET_USER_META_DATA);
		localStorage.removeItem(RESPONSE_TIME_GET_USER_META_DATA);
		localStorage.removeItem(REDIRECTING_TO_SUMMARY_TIME);
		localStorage.removeItem(GET_EPIC_TOKEN_AND_APP_CONTEXT_REQUEST_TIME);
		localStorage.removeItem(GET_EPIC_TOKEN_AND_APP_CONTEXT_RESPONSE_TIME);
		localStorage.removeItem(REDIRECTING_TO_EPIC_TIME);
		localStorage.removeItem(EPIC_LOGIN_DOC_REDIRECT_TIME);
		localStorage.removeItem(REQUEST_TO_AUTH0_TOKEN_TIME);
		localStorage.removeItem(RESPONSE_FROM_AUTH0_TOKEN_TIME);

		const analytics = getOrCreateAnalytics();

		analytics.track(analytics.idsNames.UserTrackingTimeCheck, {
			timeDiffBetweenLunchToRiderect: timeDiffBetweenLunchToRedirect,
			timeDiffBetweenRedirectToRedirectBack,
			timeDiffBetweenRedirectBackToApiCall,
			timeDifffGetUserMetaDataResponse,
			timeDiffGettingEpicTokenAndContextData,
			loadingSummeryTime,
			completeTime: completeLoadingTime,
			lunchTime,
			redirectTime,
			redirectBackTime,
			requestTimeGetUserMetaData,
			responseTimeGetUserMetaData,
			redirectToSummaryTime,
			responseTimeGetEpicTokenAndAppcContext,
			requestTimeGetEpicTokenAndAppcContext,
			applicationLoadTimeCompleteFlow,
			isEpicDocFlow,
			redirectTimeFromAuth0,
			redirectTimeFromEpic,
			loadingDocsTime,
			auth0TokenResponseTime,
			isEpicRedirectFlow: !(responseTimeGetUserMetaData && requestTimeGetUserMetaData),
		});

		getOrCreateLogger().warn('Time taken for epic flow to complete', {
			timeDiffBetweenLunchToRiderect: timeDiffBetweenLunchToRedirect,
			timeDiffBetweenRedirectToRedirectBack,
			timeDiffBetweenrdirectBackToGetUserMetaDataRequest: timeDiffBetweenRedirectBackToApiCall,
			timeDifffGetUserMetaDataResponse,
			timeDiffBetweenGetEpicTokenAndAppcContextRequest: timeDiffGettingEpicTokenAndContextData,
			loadingSummeryTime,
			completeTime: completeLoadingTime,
			lunchTime,
			redirectTime,
			redirectBackTime,
			requestTimeGetUserMetaData,
			responseTimeGetUserMetaData,
			redirectToSummaryTime,
			responseTimeGetEpicTokenAndAppcContext,
			requestTimeGetEpicTokenAndAppcContext,
			applicationLoadTimeCompleteFlow,
			isEpicDocFlow,
			loadingDocsTime,
			redirectTimeFromAuth0,
			redirectTimeFromEpic,
			auth0TokenResponseTime,
			isEpicRedirectFlow: !(responseTimeGetUserMetaData && responseTimeGetEpicTokenAndAppcContext),
		});
	}
};
